import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import { initSelect2Baremo } from "../utils/select2_baremo"

export default class extends Controller {
  static targets = ["baremoSelect"]
  static values = { refundRequestId: Number, detailId: Number }

  update(event) {
    const nombreBeneficio = event.target.value

    if (!nombreBeneficio) {
      this.reemplazarOpciones([])
      return
    }

    const params = new URLSearchParams({
      nombre_beneficio: nombreBeneficio,
      refund_request_detail_id: this.detailIdValue
    })

    fetch(`/refund_requests/${this.refundRequestIdValue}/update_baremo_definitions?${params}`, {
      headers: { "Accept": "application/json" }
    })
      .then(response => response.json())
      .then(baremoDefinitions => this.reemplazarOpciones(baremoDefinitions))
      .catch(() => this.reemplazarOpciones([]))
  }

  reemplazarOpciones(baremoDefinitions) {
    //data que viene del baremo
    //console.log('data')
    //console.log(baremoDefinitions)

    const select = this.baremoSelectTarget
    const valorActual = select.value

    select.innerHTML = ""
    select.appendChild(new Option("- Seleccione -", ""))
    baremoDefinitions.forEach(baremoDefinition => {
      select.appendChild(new Option(baremoDefinition.descripcion, baremoDefinition.id))
    })

    const sigueDisponible = baremoDefinitions.some(baremoDefinition => String(baremoDefinition.id) === valorActual)
    select.value = sigueDisponible ? valorActual : ""

    initSelect2Baremo($(select))
  }
}
